<template>
    <div class="box">
        <img
            class="home"
            src="https://i.gsxcdn.com/2444846502_pq81l10i.png"
            alt=""
            @click="gotoHome"
        >
        <div class="box-list" v-for="(item, index) in bookData" :key="index">
            <div class="box-list-title">
                {{item.title}}
            </div>
            <div class="box-list-name" v-if="item.type === 2">
                {{item.content}}
            </div>
            <div class="box-list-imgbox" v-if="item.type === 1">
                <img class="img" :src="item.content" alt="">
            </div>
        </div>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';
import {bookList} from '@/api/api';

@Options({
    components: {
    },
    created() {
        if (!this.$route.query.id) {
            this.gotoHome();
            return;
        }
        this.bookList();
    }
})
export default class AnswerList extends Vue {
    bookData = [];

    async bookList() {
        const {id, courseLevel} = this.$route.query;
        const res = await bookList({
            bookParam: id,
            courseLevel: this.$route.name === 's3answer' ? 3 : +courseLevel || 2
        });
        if (res.code === '0') {
            this.bookData = res.data?.list;
        }
        else {
            this.$toast(res.msg);
        }
    }

    gotoHome() {
        const {id, courseLevel} = this.$route.query;
        this.$router.replace({
            path: '/answerList',
            query: {
                courseLevel: this.$route.name === 's3answer' ? 3 : +courseLevel || 2
            }
        });
    }
}
</script>

<style lang="scss" scoped>
.box {
    width: 100vw;
    min-height: 100vh;
    padding-top: .43rem;

    .home {
        width: 1.17rem;
        height: 1.17rem;
        position: fixed;
        top: 0;
        right: .24rem;
    }

    &-list {
        width: 100%;
        padding-left: .48rem;
        padding-bottom: .64rem;
        box-sizing: border-box;

        &-title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: .4rem;
            color: #0B0B0B;
            line-height: .51rem;
            text-align: left;
            font-style: normal;
            margin-bottom: .32rem;
        }

        &-name {
            width: 9.15rem;
            padding: .4rem;
            border-radius: .32rem;
            border: .01rem solid #F1F1F1;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: .4rem;
            color: #333333;
            line-height: .61rem;
            text-align: left;
            font-style: normal;
            box-sizing: border-box;
        }

        &-imgbox {
            width: 9.15rem;
            padding: .4rem;
            border-radius: .32rem;
            border: .01rem solid #F1F1F1;
            box-sizing: border-box;

            .img {
                width: 8.35rem;
            }
        }
    }
}

</style>
